<footer class="bg-gray-100 text-gray-600 border-t border-gray-200 mt-20">
  <div class="container mx-auto py-14 px-4">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
      <!-- Logo & Description -->
      <div
        class="lg:col-span-2 flex flex-col items-center md:items-start text-center md:text-left"
      >
        <div class="flex items-center gap-3 mb-4 cursor-pointer" routerLink="/">
          <img src="./helageek.png" alt="Logo" class="md:h-10 h-8 w-auto" />
        </div>
        <p class="text-gray-600 text-sm leading-relaxed max-w-sm">
          Your trusted partner for custom merchandise - bringing your unique
          ideas to life with style and premium quality.
        </p>
      </div>

      <!-- Categories -->
      <div class="text-center md:text-left">
        <h4
          class="font-bold text-gray-900 mb-4 text-base uppercase tracking-wider"
        >
          Shop Categories
        </h4>
        <ul class="space-y-2.5 text-sm">
          @for (cat of categories; track $index) {
            <li>
              <a
                (click)="goToCategory(cat)"
                class="hover:text-[var(--primary)] transition-colors cursor-pointer"
                >{{ cat }}</a
              >
            </li>
          }
        </ul>
      </div>

      <!-- Quick Links -->
      <div class="text-center md:text-left">
        <h4
          class="font-bold text-gray-900 mb-4 text-base uppercase tracking-wider"
        >
          Quick Links
        </h4>
        <ul class="space-y-2.5 text-sm">
          <li>
            <a
              routerLink="/"
              class="hover:text-[var(--primary)] transition-colors"
              >Home</a
            >
          </li>
          <li>
            <a
              routerLink="/products"
              class="hover:text-[var(--primary)] transition-colors"
              >Products</a
            >
          </li>
          <li>
            <a
              routerLink="/gifts"
              class="hover:text-[var(--primary)] transition-colors"
              >Custom Gifts</a
            >
          </li>
          <li>
            <a
              routerLink="/profile"
              class="hover:text-[var(--primary)] transition-colors"
              >Profile</a
            >
          </li>
          <li>
            <a
              routerLink="/orders"
              class="hover:text-[var(--primary)] transition-colors"
              >Orders</a
            >
          </li>
        </ul>
      </div>

      <!-- Legal & Social -->
      <div class="text-center md:text-left">
        <h4
          class="font-bold text-gray-900 mb-4 text-base uppercase tracking-wider"
        >
          Legal & Social
        </h4>
        <ul class="space-y-2.5 text-sm mb-6">
          <li>
            <a
              routerLink="/privacy-policy"
              class="hover:text-[var(--primary)] transition-colors"
              >Privacy Policy</a
            >
          </li>
          <li>
            <a
              routerLink="/terms-and-conditions"
              class="hover:text-[var(--primary)] transition-colors"
              >Terms & Conditions</a
            >
          </li>
          <li>
            <a
              routerLink="/return-and-refund-policy"
              class="hover:text-[var(--primary)] transition-colors"
              >Return Policy</a
            >
          </li>
          <li>
            <a
              routerLink="/shipping-policy"
              class="hover:text-[var(--primary)] transition-colors"
              >Shipping Policy</a
            >
          </li>
        </ul>

        <div class="flex justify-center md:justify-start gap-3 text-gray-700">
          <a
            href="https://www.facebook.com/share/1CBzVK4Ax6/?mibextid=wwXIfr"
            target="_blank"
            class="w-9 h-9 rounded-full bg-white border border-gray-200 flex items-center justify-center hover:bg-[var(--primary)] hover:text-white hover:border-[var(--primary)] transition-colors"
          >
            <fa-icon [icon]="faFacebookF"></fa-icon>
          </a>
          <a
            href="https://www.linkedin.com/company/hela-geek/"
            target="_blank"
            class="w-9 h-9 rounded-full bg-white border border-gray-200 flex items-center justify-center hover:bg-[var(--primary)] hover:text-white hover:border-[var(--primary)] transition-colors"
          >
            <fa-icon [icon]="faLinkedinIn"></fa-icon>
          </a>
          <a
            href="https://www.tiktok.com/@helageekofficial?_r=1&_t=ZS-93FCkWw31Or"
            target="_blank"
            class="w-9 h-9 rounded-full bg-white border border-gray-200 flex items-center justify-center hover:bg-[var(--primary)] hover:text-white hover:border-[var(--primary)] transition-colors"
          >
            <fa-icon [icon]="faTiktok"></fa-icon>
          </a>
          <a
            href="https://www.instagram.com/hela_geek?igsh=MW02OXllbndsY3p3aw%3D%3D&utm_source=qr"
            target="_blank"
            class="w-9 h-9 rounded-full bg-white border border-gray-200 flex items-center justify-center hover:bg-[var(--primary)] hover:text-white hover:border-[var(--primary)] transition-colors"
          >
            <fa-icon [icon]="faInstagram"></fa-icon>
          </a>
          <a
            href="https://whatsapp.com/channel/0029VbCdLnj77qVLbQM1VO3C"
            target="_blank"
            class="w-9 h-9 rounded-full bg-white border border-gray-200 flex items-center justify-center hover:bg-[var(--primary)] hover:text-white hover:border-[var(--primary)] transition-colors"
          >
            <fa-icon [icon]="faWhatsapp"></fa-icon>
          </a>
        </div>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div
      class="mt-12 border-t border-gray-200 pt-6 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500 gap-4"
    >
      <p>© {{ currentYear }} Hela Geek. All rights reserved.</p>
      <p>
        Designed & Developed by
        <a
          href="https://onezerocode.com"
          target="_blank"
          class="text-[var(--primary)] font-semibold hover:underline"
        >
          One Zero Code
        </a>
      </p>
    </div>
  </div>
</footer>
